import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Preloading from "../../../components/basics/Preloading";
import methods from "../../../services/utility";
import back from "../../../assets/images/icons/arrow-right2.svg";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import apiMethod from "../../../services/api-service";
import DeleteModal from "../../../components/deleteModal/DeleteModal";
import EditIcon from "../../../assets/images/icons/editIcon.svg";
import DeleteIcon from "../../../assets/images/icons/deleteIcon.svg";
import newLogo from "../../../assets/images/icons/new.png";
import copy from "../../../assets/images/icons/copy.png";
import Paginations from "../../../components/paginaton/Paginations";

const PurchaseOrder = () => {
  const { restaurantId } = useParams();
  const [loading, setLoading] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [selectId, setSelectId] = useState(null);
  const [suppliers, setSuppliers] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [filterModel, setFilterModel] = useState({
    restaurantId: restaurantId,
    title: "",
    purchaseOrderStatus: 1,
    startDate: "",
    endDate: "",
    size: 10,
    part: 1,
    parts: 0,
    total: 0,
  });
  const [formModel, setFormModel] = useState({
    id: 0,
    title: "",
    deliveryDate: "",
    description: "",
    purchaseOrderStatus: 1,
    supplierId: "",
    restaurantId: restaurantId,
  });

  const [supplierItems, setSupplierItems] = useState({
    restaurantId: restaurantId,
    title: "",
    size: 100,
    part: 1,
  });

  const getSuppliers = async () => {
    setLoading(true);
    const resp = await apiMethod.getSuppliers(
      supplierItems.restaurantId,
      supplierItems.title,
      supplierItems.size,
      supplierItems.part
    );
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }
    setSuppliers(resp.data);
    setLoading(false);
  };

  const getGridData = async (customPart = null) => {
    const part = customPart ? customPart : filterModel.part;
    setLoading(true);
    const resp = await apiMethod.getPurchaseOrders(
      filterModel.restaurantId,
      filterModel.title,
      filterModel.purchaseOrderStatus,
      filterModel.startDate,
      filterModel.endDate,
      filterModel.size,
      part
    );
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }
    filterModel.total = resp.total;
    filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
    filterModel.part = part;
    setFilterModel({ ...filterModel });
    setGridData(resp.data);
    setLoading(false);
  };

  useEffect(() => {
    getSuppliers();
    getGridData();
  }, []);

  const resetFilters = () => {
    filterModel.restaurantId = restaurantId;
    filterModel.title = "";
    filterModel.purchaseOrderStatus = 1;
    filterModel.startDate = "";
    filterModel.endDate = "";
    filterModel.size = 10;
    filterModel.part = 1;
    filterModel.parts = 0;
    filterModel.total = 0;
    setFilterModel({ ...filterModel });
  };

  const resetForm = () => {
    formModel.id = 0;
    formModel.title = "";
    formModel.restaurantId = restaurantId;
    formModel.deliveryDate = "";
    formModel.purchaseOrderStatus = 1;
    formModel.description = "";
    formModel.supplierId = "";
    setFormModel({ ...formModel });
  };

  const closePurchaseModal = () => {
    resetForm();
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const callPager = async (i) => {
    setLoading(true);
    setFilterModel({ ...filterModel, part: i });
    await getGridData(i);
    setLoading(false);
  };

  const clearSearch = async () => {
    resetFilters();
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const selectَItemToDelete = (item) => {
    setSelectId(item);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    resetForm();
  };

  const createItem = async () => {
    setLoading(true);
    const resp = await apiMethod.createPurchaseOrder(formModel);
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }
    await getGridData();
    resetForm();
    setLoading(false);
  };

  const editItem = async (id) => {
    setLoading(true);
    const resp = await apiMethod.getPurchaseOrderInfo(id);
    console.log(resp);
    formModel.id = resp.data.id;
    formModel.supplierId = resp.data.supplierId;
    formModel.title = resp.data.title;
    formModel.description = resp.data.description;
    formModel.deliveryDate = methods.toPersianDate(resp.data.deliveryDate);
    setFormModel({ ...formModel });
    setLoading(false);
  };

  const deleteItem = async () => {
    setLoading(true);
    const resp = await apiMethod.removePurchaseOrder(selectId.id);
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }
    await getGridData();
    resetForm();
    setLoading(false);
    setShowDeleteModal(false);
  };

  const copyItem = (item) => {
    formModel.title = item.title;
    formModel.description = item.description;
    formModel.supplierId = item.supplierId;
    formModel.deliveryDate = methods.toPersianDate(
      item.deliveryDate,
      "jYYYY/jMM/jDD"
    );
    setFormModel({ ...formModel });
    const el = document.getElementById("add_item");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const renderPurchase = () => {
    return (
      <>
        {loading && <Preloading />}
        {
          <>
            <div className="d-none d-lg-block mb-3">
              <Link
                to={`/warehouse/${restaurantId}`}
                className="text-start mb-3 link back-link"
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>
                <Link
                  to={`/warehouse/${restaurantId}`}
                  className="link back-link"
                >
                  <span>
                    <img src={back} className="" alt="return" />
                  </span>
                </Link>
                ثبت سفارش خرید
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>
                ثبت سفارش خرید
                <a
                  href={`/wareHouse/${restaurantId}/`}
                  className="link rtlicon me-1"
                  title="برای اطلاعات بیشتر کلیک کنید"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            <div className="salemain mb-3" id="add_item">
              <div className="d-flex align-items-center gap-4 justify-content-end">
                <button className="btn-action" onClick={resetForm}>
                  <img src={newLogo} alt="Image" />
                  <span style={{ fontSize: "12px" }}>جدید</span>
                </button>
              </div>
              <div className="mb-3">
                <span className="fw-bold fs-5">
                  افزودن / ویرایش ثبت سفارش خرید
                </span>
              </div>
              <div className="row g-2">
                <div className="col-12 col-md-4">
                  <label htmlFor="title" className="form-label required-label">
                    عنوان
                  </label>
                  <input
                    className="form-control input-form"
                    type="text"
                    id="title"
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={formModel.title}
                    onChange={(e) => {
                      formModel.title = e.target.value;
                      setFormModel({ ...formModel });
                    }}
                    placeholder="عنوان را بنویسید"
                  />
                </div>
                <div className="col-12 col-md-4">
                  <label
                    htmlFor="startDate"
                    className="form-label required-label"
                  >
                    مهلت خرید
                  </label>
                  <DatePicker
                    calendar={persian}
                    id="startDate"
                    locale={persian_fa}
                    calendarPosition="bottom-center"
                    format="YYYY/MM/DD"
                    value={formModel.deliveryDate}
                    onChange={(value) => {
                      if (value)
                        formModel.deliveryDate = value.format("YYYY/MM/DD");
                      else formModel.deliveryDate = "";
                      setFormModel({ ...formModel });
                    }}
                    placeholder="مهلت خرید را انتخاب کنید"
                    inputClass="form-control input-form"
                    containerStyle={{
                      width: "100%",
                    }}
                  />
                </div>
                <div className="col-12 col-md-4">
                  <label
                    htmlFor="supplier"
                    className="form-label required-label"
                  >
                    تامین کننده
                  </label>
                  <select
                    id="supplier"
                    className="form-select input-select"
                    aria-label="Default select example"
                    value={formModel.supplierId}
                    onChange={(e) => {
                      formModel.supplierId = e.target.value;
                      setFormModel({ ...formModel });
                    }}
                  >
                    <option value={0}>انتخاب کنید</option>
                    {suppliers.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-12 mt-3">
                  <label htmlFor="description" className="form-label">
                    توضیحات
                  </label>
                  <textarea
                    type="text"
                    className="form-control input-textarea"
                    id="description"
                    name="description"
                    rows={3}
                    value={formModel.description}
                    onChange={(e) => {
                      setFormModel({
                        ...formModel,
                        description: e.target.value,
                      });
                    }}
                    placeholder="توضیحات را بنویسید"
                  />
                </div>
              </div>
              <div class="d-flex align-items-center justify-content-end gap-3 mt-4">
                <button
                  type="button"
                  class="btn custome-btn btn-link-purple"
                  onClick={closePurchaseModal}
                >
                  انصراف
                </button>
                <button
                  type="button"
                  class="btn custome-btn btn-purple"
                  onClick={createItem}
                >
                  ثبت و ذخیره
                </button>
              </div>
            </div>
            <div className="salemain mb-3">
              <div className="row align-items-end g-3">
                <div className="col-12 col-md-3">
                  <div>
                    <label htmlFor="searchInput" className="form-label">
                      عنوان
                    </label>
                    <input
                      id="searchInput"
                      className="form-control input-form"
                      type="text"
                      aria-label="Add your item here..."
                      style={{ direction: "rtl", textAlign: "right" }}
                      value={filterModel.title}
                      onChange={(e) => {
                        setFilterModel({
                          ...filterModel,
                          title: e.target.value,
                          part: 1,
                        });
                      }}
                      placeholder="جتسجو کنید..."
                    />
                  </div>
                </div>
                <div className="col-12 col-md-2">
                  <div className="d-flex align-items-center gap-2">
                    <button
                      className="btn-wrap search-btn"
                      onClick={searchItem}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                    <button
                      className="btn-wrap reset-btn"
                      onClick={clearSearch}
                    >
                      <i className="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="salemain">
              <div className="d-flex align-items-center justify-content-between">
                <span className="d-block text-start fw-bold fs-5">
                  سفارش های خرید
                </span>
              </div>
              <div className="table-responsive warhousetable">
                <table className="table table-md table-custom">
                  <thead className="align-middle">
                    <tr>
                      <th scope="col vertical-center" width="20px">
                        ردیف
                      </th>
                      <th scope="col vertical-center">عنوان</th>
                      <th scope="col vertical-center">تاریخ ثبت</th>
                      <th scope="col vertical-center">تامین کننده</th>
                      <th scope="col vertical-center">وضعیت سفارش</th>
                      <th scope="col vertical-center">مهلت خرید</th>
                      <th scope="col vertical-center">اقلام</th>
                      <th scope="col vertical-center">توضیحات</th>
                      <th scope="col vertical-center">عملیات</th>
                    </tr>
                  </thead>
                  <tbody className="align-middle">
                    {gridData.map((item, index) => (
                      <tr key={item.id}>
                        <th scope="row">
                          {(filterModel.part - 1) * filterModel.size +
                            index +
                            1}
                        </th>
                        <td>{item.title}</td>
                        <td>
                          {methods.toPersianDate(
                            item.createDate,
                            "jYYYY/jMM/jDD"
                          )}
                        </td>
                        <td>{item.supplierTitle}</td>
                        <td>{item.orderStatusTitle}</td>
                        <td>
                          {methods.toPersianDate(
                            item.deliveryDate,
                            "jYYYY/jMM/jDD"
                          )}
                        </td>
                        <td>
                          <Link
                            to={`/warehouse/${restaurantId}/${item.supplierId}/orderItems/${item.id}`}
                          >
                            <button className="btn btn-purple btn-sm">
                              اقلام سفارش ({item.orderItemCount})
                            </button>
                          </Link>
                        </td>
                        <td>{item.description}</td>
                        <td className="d-flex align-items-center justify-content-center gap-2">
                          <button
                            className="button-action copy-btn"
                            onClick={() => copyItem(item)}
                          >
                            <img src={copy} alt="Copy" />
                          </button>
                          <button
                            onClick={() => editItem(item.id)}
                            className="button-action"
                            type="button"
                          >
                            <img src={EditIcon} alt="Edit" />
                          </button>
                          <button
                            onClick={() => selectَItemToDelete(item)}
                            className="button-action"
                            type="button"
                          >
                            <img src={DeleteIcon} alt="delete" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {filterModel.parts > 1 && (
                  <div className="pagination justify-content-center mt-5">
                    <Paginations
                      total={filterModel.total}
                      size={filterModel.size}
                      onPageChange={callPager}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        }
      </>
    );
  };

  return (
    <>
      {renderPurchase()}
      {showDeleteModal && (
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeDeleteModal}
          deleteItem={deleteItem}
          text={"سفارش"}
        />
      )}
    </>
  );
};

export default PurchaseOrder;
